'use client'

import { useRouter as useAppRouter } from 'next/navigation'
import { useRouter as usePagesRouter } from 'next/router'
import { useSearchParams } from 'next/navigation'
import { usePathname } from 'next/navigation'

export function useUnifiedRouter() {
  // Try app router first
  try {
    const router = useAppRouter()
    const searchParams = useSearchParams()
    const pathname = usePathname()

    return {
      router,
      query: Object.fromEntries(searchParams?.entries() || []),
      pathname,
      isAppRouter: true,
    }
  } catch {
    // Fallback to pages router
    const router = usePagesRouter()

    return {
      router,
      query: router.query,
      pathname: router.pathname,
      isAppRouter: false,
    }
  }
}
